module.exports = __webpack_public_path__ + "img/bot.53ca4790.png";